/* eslint-disable eqeqeq */
import { Container, Divider, Grid, ThemeProvider, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useTranslation } from "react-i18next";
import Check from "../../../assets/logo/check.svg";
import { findCurrency, formatCryptoDecimals, formatNumber,  getCommonConsts, isFiatTransaction, isTotalFeeAvailable, trimText } from "../../../utils";
import { succesTheme } from "../theme";
import AppStatus from "../../../components/AppStatus";
import AppButton from "../../../components/AppButton";
import { HomeOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import AppToolTip from "../../../components/AppTooltip";
import FeedbackSurvey from "./FeedbackSurvey";
import { useSelector } from "react-redux";
import AppFeeComponent from "../../../components/AppFeeComponent";

export default function SuccessComponent({ withdrawData }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const account = useSelector(({ Auth }) => Auth?.account);
  const paymentMethod = withdrawData?.accountData?.data?.paymentMethod || withdrawData?.feeCharged?.paymentMethodDisplayName;
  const showFees = (data) => {
    if (data?.feeCharged?.hasOwnProperty('feeEnabled')) {
      return data?.feeCharged?.feeEnabled;
    }
    return true;
  }
  return (
    <ThemeProvider theme={succesTheme}>
      <Container maxWidth="md" sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <Grid container sx={{ color: "#F8FAFF" }}>
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                flexFlow: "column",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Check style={{ width: 94, height: 94 }} />
              <Typography
                color={"#F8FAFF"}
                textAlign="center"
                marginTop={3}
                fontWeight={700}
                fontSize={24}
              >
                {t("TransferInitiateSuccessfully")}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Typography fontSize={14} fontWeight={400}>
              {t("status")}:
            </Typography>
          </Grid>
          <Grid item xs={8} textAlign="right">
            <AppStatus status={parseFloat(withdrawData.status.toString())} />
          </Grid>
          <Grid item xs={4}>
            {t("Amount Requested")}:
          </Grid>
          <Grid item xs={8} textAlign="right">
            {withdrawData.amount} {withdrawData.currency}
          </Grid>
          {!!paymentMethod && <>
            <Grid item xs={4}>
              {t('paymentMethod')}
            </Grid>
            <Grid item xs={8} textAlign="right">
              {getCommonConsts(paymentMethod)}
            </Grid>
          </>}
          <Grid item xs={5}>
            {t('Currency requested')}:
          </Grid>
          {!isFiatTransaction(withdrawData) && <Grid item xs={7} textAlign="right">
            {withdrawData?.cryptoCurrency?.id
              ? `${withdrawData?.cryptoCurrency?.id}`
              : ``}&nbsp;({
              withdrawData?.cryptoNetwork?.toUpperCase()
            })
          </Grid>}
          {isFiatTransaction(withdrawData) && <Grid item xs={7} textAlign="right">
            {withdrawData.feeCharged.currency}
          </Grid>}

          {
            (!isFiatTransaction(withdrawData) && isTotalFeeAvailable(withdrawData)) &&
            <Grid item xs={12}>
              <AppFeeComponent withdrawData={withdrawData} />
            </Grid>
          }
          {(showFees(withdrawData) && !isTotalFeeAvailable(withdrawData)) && <Grid item xs={4}>
            {t("processing-fee")}:
          </Grid>}
          {(!isFiatTransaction(withdrawData) && showFees(withdrawData) && !isTotalFeeAvailable(withdrawData) && (withdrawData?.feeCharged?.localProcessingFeeFiat || withdrawData?.feeCharged?.processingFeePercent)) && <Grid item xs={8} textAlign="right">
            {withdrawData.feeCharged.localProcessingFeeFiat} {withdrawData?.feeCharged?.baseCurrency} {(withdrawData.feeCharged.processingFeePercent != 0 && withdrawData?.feeCharged?.processingFeePercent) ? `+ ${withdrawData.feeCharged.processingFeePercent}%` : ""}
          </Grid>}
          {
            (isFiatTransaction(withdrawData) && showFees(withdrawData)) && <Grid item xs={8} textAlign="right">
              {withdrawData.feeCharged.localProcessingFeeFlat} {withdrawData?.feeCharged?.baseCurrency} {(withdrawData.feeCharged.processingFeePercent != 0) ? `+ ${withdrawData.feeCharged.processingFeePercent}%` : ""}
            </Grid>
          }
          {/* {!!withdrawData?.feeCharged?.networkFeeCrypto && (
            <>
              <Grid item xs={4}>
              {t('Network fees')}:
              </Grid>
              <Grid item xs={8} textAlign="right">
                {formatCryptoDecimals(withdrawData.feeCharged.networkFeeUsd)}&nbsp;
                {withdrawData?.currency} 
              </Grid>
            </>
          )} */}
          <Grid item xs={4}>
            {t("Amount To Be Sent")}:
          </Grid>
          {!isFiatTransaction(withdrawData) && <Grid item xs={8} textAlign="right">
            {formatNumber(Number(withdrawData.feeCharged?.localPayoutAmount))}{" "}
            {withdrawData?.currency}
          </Grid>}
          {isFiatTransaction(withdrawData) && <Grid item xs={8} textAlign="right">
            {formatNumber(Number(withdrawData.feeCharged?.localPayoutAmount))}&nbsp;
            {withdrawData?.currency} 
          </Grid>}

          {((withdrawData?.feeCharged?.baseCurrency !== withdrawData?.currency && isFiatTransaction(withdrawData)) || !isFiatTransaction(withdrawData)) && <Grid item xs={4}>
            {t('exchangeRate')}:
          </Grid>}
          {!isFiatTransaction(withdrawData) && <Grid item xs={8} textAlign="right">
            1 {withdrawData.cryptoCurrency.id} ={" "}
            {formatCryptoDecimals(
              withdrawData.feeCharged.cryptoCurrencyCurrentRate
            )}
            &nbsp;
            {withdrawData?.currency}
          </Grid>}
          {findCurrency(account) !== withdrawData?.currency && isFiatTransaction(withdrawData) && <Grid item xs={8} textAlign="right">
            <span>1 {findCurrency(account)} =  </span>
            <AppToolTip
              enterTouchDelay={0}
              title={`${withdrawData?.feeCharged?.rkflRate?.toString()} ${withdrawData?.feeCharged?.currency}`}
              placement="top" arrow>
              <span>{trimText(withdrawData?.feeCharged?.rkflRate?.toString(), 6)}</span>
            </AppToolTip>&nbsp;{withdrawData?.feeCharged?.currency}
          </Grid>}
        </Grid>
        <Divider sx={{ marginTop: 2, marginBottom: 2 }} />
        <Box
          sx={{
            display: "flex",
            flexFlow: "row",
            justifyContent: "space-between",
            marginTop: 2,
          }}
        >
          <Typography fontSize={16} color="#F8FAFF">
            {t("AmountReceived")}:
          </Typography>
          <Box>
            {!isFiatTransaction(withdrawData) && <Typography
              fontSize={16}
              fontWeight={400}
              color="#F8FAFF"
              textAlign={"right"}
            >
              {formatCryptoDecimals(withdrawData.feeCharged.payoutAmountCrypto)}{" "}
              {withdrawData?.cryptoCurrency?.id}
            </Typography>}
            {isFiatTransaction(withdrawData) && <Typography
              fontSize={16}
              fontWeight={400}
              color="#F8FAFF"
              textAlign={"right"}
            >
              {formatNumber(withdrawData.feeCharged.payoutAmount)}{" "}
              {withdrawData?.feeCharged?.currency}
            </Typography>}
          </Box>
        </Box>
        {!isFiatTransaction(withdrawData) && <Typography
          variant="subtitle1"
          color={"#D4D4D8"}
          textAlign={"center"}
          fontSize={12}
          marginTop={2}
          lineHeight={1.5}
        >
          {t("transfer.disclaimer3")}
        </Typography>}
        <FeedbackSurvey />
        <AppButton
          sx={{ marginTop: 2, marginBottom: 4 }}
          startIcon={<HomeOutlined />}
          onClick={() => navigate("/home", {
            state: {
              showFeedbackForm: true
            },
          })}
          title={t("BackDashboard")}
        ></AppButton>
      </Container>
    </ThemeProvider>
  );
}
